// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WebinarIdRouteImport } from './routes/$webinarId'
import { Route as AccessDeniedRouteImport } from './routes/access-denied'
import { Route as CreateRouteImport } from './routes/create'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as OnDemandRouteImport } from './routes/on-demand'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as SwitchAccountRouteImport } from './routes/switch-account'
import { Route as TestSuiteRouteImport } from './routes/test-suite'
import { Route as UpcomingRouteImport } from './routes/upcoming'
import { Route as WebinarIdIndexRouteImport } from './routes/$webinarId.index'
import { Route as WebinarIdAnalyticsRouteImport } from './routes/$webinarId.analytics'
import { Route as WebinarIdAttachmentsRouteImport } from './routes/$webinarId.attachments'
import { Route as WebinarIdBroadcastRouteImport } from './routes/$webinarId.broadcast'
import { Route as WebinarIdChaptersRouteImport } from './routes/$webinarId.chapters'
import { Route as WebinarIdChatMessagesRouteImport } from './routes/$webinarId.chat-messages'
import { Route as WebinarIdChatSettingsRouteImport } from './routes/$webinarId.chat-settings'
import { Route as WebinarIdContentRouteImport } from './routes/$webinarId.content'
import { Route as WebinarIdDeleteRouteImport } from './routes/$webinarId.delete'
import { Route as WebinarIdEditRouteImport } from './routes/$webinarId.edit'
import { Route as WebinarIdEditExamRouteImport } from './routes/$webinarId.edit-exam'
import { Route as WebinarIdEditSubtitlesRouteImport } from './routes/$webinarId.edit-subtitles'
import { Route as WebinarIdEditSurveyRouteImport } from './routes/$webinarId.edit-survey'
import { Route as WebinarIdEditVideoRouteImport } from './routes/$webinarId.edit-video'
import { Route as WebinarIdExamRouteImport } from './routes/$webinarId.exam'
import { Route as WebinarIdExamResultRouteImport } from './routes/$webinarId.exam-result'
import { Route as WebinarIdForgotPasswordRouteImport } from './routes/$webinarId.forgot-password'
import { Route as WebinarIdInsightsRouteImport } from './routes/$webinarId.insights'
import { Route as WebinarIdInterestedAccountsRouteImport } from './routes/$webinarId.interested-accounts'
import { Route as WebinarIdLiveParticipantsRouteImport } from './routes/$webinarId.live-participants'
import { Route as WebinarIdLiveTranscribeRouteImport } from './routes/$webinarId.live-transcribe'
import { Route as WebinarIdLoginRouteImport } from './routes/$webinarId.login'
import { Route as WebinarIdOnDemandRouteImport } from './routes/$webinarId.on-demand'
import { Route as WebinarIdOnDemandParticipantsRouteImport } from './routes/$webinarId.on-demand-participants'
import { Route as WebinarIdPollResultRouteImport } from './routes/$webinarId.poll-result'
import { Route as WebinarIdRegisterRouteImport } from './routes/$webinarId.register'
import { Route as WebinarIdSecurityRouteImport } from './routes/$webinarId.security'
import { Route as WebinarIdShareRouteImport } from './routes/$webinarId.share'
import { Route as WebinarIdSlideControllerRouteImport } from './routes/$webinarId.slide-controller'
import { Route as WebinarIdSlideDeckRouteImport } from './routes/$webinarId.slide-deck'
import { Route as WebinarIdSlideViewerRouteImport } from './routes/$webinarId.slide-viewer'
import { Route as WebinarIdSurveyRouteImport } from './routes/$webinarId.survey'
import { Route as WebinarIdSurveyResultRouteImport } from './routes/$webinarId.survey-result'
import { Route as WebinarIdWatchRouteImport } from './routes/$webinarId.watch'
import { Route as AccountManagerInviteInviteCodeRouteImport } from './routes/account-manager-invite.$inviteCode'
import { Route as AccountTabRouteImport } from './routes/account.$tab'
import { Route as ManageIndexRouteImport } from './routes/manage.index'
import { Route as ManageBlacklistRouteImport } from './routes/manage.blacklist'
import { Route as ManageChatLinkDomainsRouteImport } from './routes/manage.chat-link-domains'
import { Route as ManageEmailStyleRouteImport } from './routes/manage.email-style'
import { Route as ManageTranslationRouteImport } from './routes/manage.translation'
import { Route as ManageUsageStatisticsRouteImport } from './routes/manage.usage-statistics'
import { Route as ManageWebinarDurationRouteImport } from './routes/manage.webinar-duration'
import { Route as OrganizedIndexRouteImport } from './routes/organized.index'
import { Route as OrganizedTabRouteImport } from './routes/organized.$tab'
import { Route as RAccountInviteIdRouteImport } from './routes/r.$accountInviteId'
import { Route as ResetPasswordResetCodeRouteImport } from './routes/reset-password.$resetCode'
import { Route as UnsubscribeTokenRouteImport } from './routes/unsubscribe.$token'
import { Route as VerifyAccountVerificationCodeRouteImport } from './routes/verify-account.$verificationCode'
import { Route as WLinkCodeRouteImport } from './routes/w.$linkCode'
import { Route as WebinarIdAChar123AuthorizationCodeChar125RouteImport } from './routes/$webinarId.a.{-$authorizationCode}'
import { Route as WebinarIdBLinkCodeRouteImport } from './routes/$webinarId.b.$linkCode'
import { Route as WebinarIdFollowUpIndexRouteImport } from './routes/$webinarId.follow-up.index'
import { Route as WebinarIdInvitesIndexRouteImport } from './routes/$webinarId.invites.index'
import { Route as WebinarIdInvitesImportRouteImport } from './routes/$webinarId.invites.import'
import { Route as WebinarIdMLinkCodeRouteImport } from './routes/$webinarId.m.$linkCode'
import { Route as WebinarIdMarketingIndexRouteImport } from './routes/$webinarId.marketing.index'
import { Route as WebinarIdMarketingIdRouteImport } from './routes/$webinarId.marketing.$id'
import { Route as WebinarIdMarketingImportRouteImport } from './routes/$webinarId.marketing.import'
import { Route as WebinarIdOLinkCodeRouteImport } from './routes/$webinarId.o.$linkCode'
import { Route as WebinarIdPollsIndexRouteImport } from './routes/$webinarId.polls.index'
import { Route as WebinarIdSLinkCodeRouteImport } from './routes/$webinarId.s.$linkCode'
import { Route as WebinarIdWLinkCodeRouteImport } from './routes/$webinarId.w.$linkCode'
import { Route as ManageAccountInvitesIndexRouteImport } from './routes/manage.account-invites.index'
import { Route as ManageAccountInvitesImportRouteImport } from './routes/manage.account-invites.import'
import { Route as ManageEmailListsIndexRouteImport } from './routes/manage.email-lists.index'
import { Route as ManageEmailListsIdRouteImport } from './routes/manage.email-lists.$id'
import { Route as ManageEmailListsImportRouteImport } from './routes/manage.email-lists.import'
import { Route as ManageEmailTemplateIndexRouteImport } from './routes/manage.email-template.index'
import { Route as WebinarIdFollowUpFollowUpIdIndexRouteImport } from './routes/$webinarId.follow-up.$followUpId.index'
import { Route as WebinarIdFollowUpFollowUpIdProcessedRouteImport } from './routes/$webinarId.follow-up.$followUpId.processed'
import { Route as WebinarIdMarketingIdSelectListRouteImport } from './routes/$webinarId.marketing.$id.select-list'
import { Route as WebinarIdPollsPollIdWeightingRouteImport } from './routes/$webinarId.polls.$pollId.weighting'
import { Route as ManageEmailTemplateTemplateTypeIndexRouteImport } from './routes/manage.email-template.$templateType.index'
import { Route as ManageEmailTemplateTemplateTypeSubTemplateRouteImport } from './routes/manage.email-template.$templateType.$subTemplate'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const WebinarIdRoute = WebinarIdRouteImport.update({
            id: '/$webinarId',path: '/$webinarId',getParentRoute: () => rootRouteImport
          })
const AccessDeniedRoute = AccessDeniedRouteImport.update({
            id: '/access-denied',path: '/access-denied',getParentRoute: () => rootRouteImport
          })
const CreateRoute = CreateRouteImport.update({
            id: '/create',path: '/create',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const NotFoundRoute = NotFoundRouteImport.update({
            id: '/not-found',path: '/not-found',getParentRoute: () => rootRouteImport
          })
const OnDemandRoute = OnDemandRouteImport.update({
            id: '/on-demand',path: '/on-demand',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const SwitchAccountRoute = SwitchAccountRouteImport.update({
            id: '/switch-account',path: '/switch-account',getParentRoute: () => rootRouteImport
          })
const TestSuiteRoute = TestSuiteRouteImport.update({
            id: '/test-suite',path: '/test-suite',getParentRoute: () => rootRouteImport
          })
const UpcomingRoute = UpcomingRouteImport.update({
            id: '/upcoming',path: '/upcoming',getParentRoute: () => rootRouteImport
          })
const WebinarIdIndexRoute = WebinarIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdAnalyticsRoute = WebinarIdAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdAttachmentsRoute = WebinarIdAttachmentsRouteImport.update({
            id: '/attachments',path: '/attachments',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdBroadcastRoute = WebinarIdBroadcastRouteImport.update({
            id: '/broadcast',path: '/broadcast',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdChaptersRoute = WebinarIdChaptersRouteImport.update({
            id: '/chapters',path: '/chapters',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdChatMessagesRoute = WebinarIdChatMessagesRouteImport.update({
            id: '/chat-messages',path: '/chat-messages',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdChatSettingsRoute = WebinarIdChatSettingsRouteImport.update({
            id: '/chat-settings',path: '/chat-settings',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdContentRoute = WebinarIdContentRouteImport.update({
            id: '/content',path: '/content',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdDeleteRoute = WebinarIdDeleteRouteImport.update({
            id: '/delete',path: '/delete',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdEditRoute = WebinarIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdEditExamRoute = WebinarIdEditExamRouteImport.update({
            id: '/edit-exam',path: '/edit-exam',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdEditSubtitlesRoute = WebinarIdEditSubtitlesRouteImport.update({
            id: '/edit-subtitles',path: '/edit-subtitles',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdEditSurveyRoute = WebinarIdEditSurveyRouteImport.update({
            id: '/edit-survey',path: '/edit-survey',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdEditVideoRoute = WebinarIdEditVideoRouteImport.update({
            id: '/edit-video',path: '/edit-video',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdExamRoute = WebinarIdExamRouteImport.update({
            id: '/exam',path: '/exam',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdExamResultRoute = WebinarIdExamResultRouteImport.update({
            id: '/exam-result',path: '/exam-result',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdForgotPasswordRoute = WebinarIdForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdInsightsRoute = WebinarIdInsightsRouteImport.update({
            id: '/insights',path: '/insights',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdInterestedAccountsRoute = WebinarIdInterestedAccountsRouteImport.update({
            id: '/interested-accounts',path: '/interested-accounts',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdLiveParticipantsRoute = WebinarIdLiveParticipantsRouteImport.update({
            id: '/live-participants',path: '/live-participants',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdLiveTranscribeRoute = WebinarIdLiveTranscribeRouteImport.update({
            id: '/live-transcribe',path: '/live-transcribe',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdLoginRoute = WebinarIdLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdOnDemandRoute = WebinarIdOnDemandRouteImport.update({
            id: '/on-demand',path: '/on-demand',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdOnDemandParticipantsRoute = WebinarIdOnDemandParticipantsRouteImport.update({
            id: '/on-demand-participants',path: '/on-demand-participants',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdPollResultRoute = WebinarIdPollResultRouteImport.update({
            id: '/poll-result',path: '/poll-result',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdRegisterRoute = WebinarIdRegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdSecurityRoute = WebinarIdSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdShareRoute = WebinarIdShareRouteImport.update({
            id: '/share',path: '/share',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdSlideControllerRoute = WebinarIdSlideControllerRouteImport.update({
            id: '/slide-controller',path: '/slide-controller',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdSlideDeckRoute = WebinarIdSlideDeckRouteImport.update({
            id: '/slide-deck',path: '/slide-deck',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdSlideViewerRoute = WebinarIdSlideViewerRouteImport.update({
            id: '/slide-viewer',path: '/slide-viewer',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdSurveyRoute = WebinarIdSurveyRouteImport.update({
            id: '/survey',path: '/survey',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdSurveyResultRoute = WebinarIdSurveyResultRouteImport.update({
            id: '/survey-result',path: '/survey-result',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdWatchRoute = WebinarIdWatchRouteImport.update({
            id: '/watch',path: '/watch',getParentRoute: () => WebinarIdRoute
          })
const AccountManagerInviteInviteCodeRoute = AccountManagerInviteInviteCodeRouteImport.update({
            id: '/account-manager-invite/$inviteCode',path: '/account-manager-invite/$inviteCode',getParentRoute: () => rootRouteImport
          })
const AccountTabRoute = AccountTabRouteImport.update({
            id: '/account/$tab',path: '/account/$tab',getParentRoute: () => rootRouteImport
          })
const ManageIndexRoute = ManageIndexRouteImport.update({
            id: '/manage/',path: '/manage/',getParentRoute: () => rootRouteImport
          })
const ManageBlacklistRoute = ManageBlacklistRouteImport.update({
            id: '/manage/blacklist',path: '/manage/blacklist',getParentRoute: () => rootRouteImport
          })
const ManageChatLinkDomainsRoute = ManageChatLinkDomainsRouteImport.update({
            id: '/manage/chat-link-domains',path: '/manage/chat-link-domains',getParentRoute: () => rootRouteImport
          })
const ManageEmailStyleRoute = ManageEmailStyleRouteImport.update({
            id: '/manage/email-style',path: '/manage/email-style',getParentRoute: () => rootRouteImport
          })
const ManageTranslationRoute = ManageTranslationRouteImport.update({
            id: '/manage/translation',path: '/manage/translation',getParentRoute: () => rootRouteImport
          })
const ManageUsageStatisticsRoute = ManageUsageStatisticsRouteImport.update({
            id: '/manage/usage-statistics',path: '/manage/usage-statistics',getParentRoute: () => rootRouteImport
          })
const ManageWebinarDurationRoute = ManageWebinarDurationRouteImport.update({
            id: '/manage/webinar-duration',path: '/manage/webinar-duration',getParentRoute: () => rootRouteImport
          })
const OrganizedIndexRoute = OrganizedIndexRouteImport.update({
            id: '/organized/',path: '/organized/',getParentRoute: () => rootRouteImport
          })
const OrganizedTabRoute = OrganizedTabRouteImport.update({
            id: '/organized/$tab',path: '/organized/$tab',getParentRoute: () => rootRouteImport
          })
const RAccountInviteIdRoute = RAccountInviteIdRouteImport.update({
            id: '/r/$accountInviteId',path: '/r/$accountInviteId',getParentRoute: () => rootRouteImport
          })
const ResetPasswordResetCodeRoute = ResetPasswordResetCodeRouteImport.update({
            id: '/reset-password/$resetCode',path: '/reset-password/$resetCode',getParentRoute: () => rootRouteImport
          })
const UnsubscribeTokenRoute = UnsubscribeTokenRouteImport.update({
            id: '/unsubscribe/$token',path: '/unsubscribe/$token',getParentRoute: () => rootRouteImport
          })
const VerifyAccountVerificationCodeRoute = VerifyAccountVerificationCodeRouteImport.update({
            id: '/verify-account/$verificationCode',path: '/verify-account/$verificationCode',getParentRoute: () => rootRouteImport
          })
const WLinkCodeRoute = WLinkCodeRouteImport.update({
            id: '/w/$linkCode',path: '/w/$linkCode',getParentRoute: () => rootRouteImport
          })
const WebinarIdAChar123AuthorizationCodeChar125Route = WebinarIdAChar123AuthorizationCodeChar125RouteImport.update({
            id: '/a/{-$authorizationCode}',path: '/a/{-$authorizationCode}',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdBLinkCodeRoute = WebinarIdBLinkCodeRouteImport.update({
            id: '/b/$linkCode',path: '/b/$linkCode',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdFollowUpIndexRoute = WebinarIdFollowUpIndexRouteImport.update({
            id: '/follow-up/',path: '/follow-up/',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdInvitesIndexRoute = WebinarIdInvitesIndexRouteImport.update({
            id: '/invites/',path: '/invites/',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdInvitesImportRoute = WebinarIdInvitesImportRouteImport.update({
            id: '/invites/import',path: '/invites/import',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdMLinkCodeRoute = WebinarIdMLinkCodeRouteImport.update({
            id: '/m/$linkCode',path: '/m/$linkCode',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdMarketingIndexRoute = WebinarIdMarketingIndexRouteImport.update({
            id: '/marketing/',path: '/marketing/',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdMarketingIdRoute = WebinarIdMarketingIdRouteImport.update({
            id: '/marketing/$id',path: '/marketing/$id',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdMarketingImportRoute = WebinarIdMarketingImportRouteImport.update({
            id: '/marketing/import',path: '/marketing/import',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdOLinkCodeRoute = WebinarIdOLinkCodeRouteImport.update({
            id: '/o/$linkCode',path: '/o/$linkCode',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdPollsIndexRoute = WebinarIdPollsIndexRouteImport.update({
            id: '/polls/',path: '/polls/',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdSLinkCodeRoute = WebinarIdSLinkCodeRouteImport.update({
            id: '/s/$linkCode',path: '/s/$linkCode',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdWLinkCodeRoute = WebinarIdWLinkCodeRouteImport.update({
            id: '/w/$linkCode',path: '/w/$linkCode',getParentRoute: () => WebinarIdRoute
          })
const ManageAccountInvitesIndexRoute = ManageAccountInvitesIndexRouteImport.update({
            id: '/manage/account-invites/',path: '/manage/account-invites/',getParentRoute: () => rootRouteImport
          })
const ManageAccountInvitesImportRoute = ManageAccountInvitesImportRouteImport.update({
            id: '/manage/account-invites/import',path: '/manage/account-invites/import',getParentRoute: () => rootRouteImport
          })
const ManageEmailListsIndexRoute = ManageEmailListsIndexRouteImport.update({
            id: '/manage/email-lists/',path: '/manage/email-lists/',getParentRoute: () => rootRouteImport
          })
const ManageEmailListsIdRoute = ManageEmailListsIdRouteImport.update({
            id: '/manage/email-lists/$id',path: '/manage/email-lists/$id',getParentRoute: () => rootRouteImport
          })
const ManageEmailListsImportRoute = ManageEmailListsImportRouteImport.update({
            id: '/manage/email-lists/import',path: '/manage/email-lists/import',getParentRoute: () => rootRouteImport
          })
const ManageEmailTemplateIndexRoute = ManageEmailTemplateIndexRouteImport.update({
            id: '/manage/email-template/',path: '/manage/email-template/',getParentRoute: () => rootRouteImport
          })
const WebinarIdFollowUpFollowUpIdIndexRoute = WebinarIdFollowUpFollowUpIdIndexRouteImport.update({
            id: '/follow-up/$followUpId/',path: '/follow-up/$followUpId/',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdFollowUpFollowUpIdProcessedRoute = WebinarIdFollowUpFollowUpIdProcessedRouteImport.update({
            id: '/follow-up/$followUpId/processed',path: '/follow-up/$followUpId/processed',getParentRoute: () => WebinarIdRoute
          })
const WebinarIdMarketingIdSelectListRoute = WebinarIdMarketingIdSelectListRouteImport.update({
            id: '/select-list',path: '/select-list',getParentRoute: () => WebinarIdMarketingIdRoute
          })
const WebinarIdPollsPollIdWeightingRoute = WebinarIdPollsPollIdWeightingRouteImport.update({
            id: '/polls/$pollId/weighting',path: '/polls/$pollId/weighting',getParentRoute: () => WebinarIdRoute
          })
const ManageEmailTemplateTemplateTypeIndexRoute = ManageEmailTemplateTemplateTypeIndexRouteImport.update({
            id: '/manage/email-template/$templateType/',path: '/manage/email-template/$templateType/',getParentRoute: () => rootRouteImport
          })
const ManageEmailTemplateTemplateTypeSubTemplateRoute = ManageEmailTemplateTemplateTypeSubTemplateRouteImport.update({
            id: '/manage/email-template/$templateType/$subTemplate',path: '/manage/email-template/$templateType/$subTemplate',getParentRoute: () => rootRouteImport
          })





const WebinarIdMarketingIdRouteChildren = {
  WebinarIdMarketingIdSelectListRoute: WebinarIdMarketingIdSelectListRoute
}

const WebinarIdMarketingIdRouteWithChildren = WebinarIdMarketingIdRoute._addFileChildren(WebinarIdMarketingIdRouteChildren)



const WebinarIdRouteChildren = {
  WebinarIdAnalyticsRoute: WebinarIdAnalyticsRoute,WebinarIdAttachmentsRoute: WebinarIdAttachmentsRoute,WebinarIdBroadcastRoute: WebinarIdBroadcastRoute,WebinarIdChaptersRoute: WebinarIdChaptersRoute,WebinarIdChatMessagesRoute: WebinarIdChatMessagesRoute,WebinarIdChatSettingsRoute: WebinarIdChatSettingsRoute,WebinarIdContentRoute: WebinarIdContentRoute,WebinarIdDeleteRoute: WebinarIdDeleteRoute,WebinarIdEditRoute: WebinarIdEditRoute,WebinarIdEditExamRoute: WebinarIdEditExamRoute,WebinarIdEditSubtitlesRoute: WebinarIdEditSubtitlesRoute,WebinarIdEditSurveyRoute: WebinarIdEditSurveyRoute,WebinarIdEditVideoRoute: WebinarIdEditVideoRoute,WebinarIdExamRoute: WebinarIdExamRoute,WebinarIdExamResultRoute: WebinarIdExamResultRoute,WebinarIdForgotPasswordRoute: WebinarIdForgotPasswordRoute,WebinarIdInsightsRoute: WebinarIdInsightsRoute,WebinarIdInterestedAccountsRoute: WebinarIdInterestedAccountsRoute,WebinarIdLiveParticipantsRoute: WebinarIdLiveParticipantsRoute,WebinarIdLiveTranscribeRoute: WebinarIdLiveTranscribeRoute,WebinarIdLoginRoute: WebinarIdLoginRoute,WebinarIdOnDemandRoute: WebinarIdOnDemandRoute,WebinarIdOnDemandParticipantsRoute: WebinarIdOnDemandParticipantsRoute,WebinarIdPollResultRoute: WebinarIdPollResultRoute,WebinarIdRegisterRoute: WebinarIdRegisterRoute,WebinarIdSecurityRoute: WebinarIdSecurityRoute,WebinarIdShareRoute: WebinarIdShareRoute,WebinarIdSlideControllerRoute: WebinarIdSlideControllerRoute,WebinarIdSlideDeckRoute: WebinarIdSlideDeckRoute,WebinarIdSlideViewerRoute: WebinarIdSlideViewerRoute,WebinarIdSurveyRoute: WebinarIdSurveyRoute,WebinarIdSurveyResultRoute: WebinarIdSurveyResultRoute,WebinarIdWatchRoute: WebinarIdWatchRoute,WebinarIdIndexRoute: WebinarIdIndexRoute,WebinarIdAChar123AuthorizationCodeChar125Route: WebinarIdAChar123AuthorizationCodeChar125Route,WebinarIdBLinkCodeRoute: WebinarIdBLinkCodeRoute,WebinarIdInvitesImportRoute: WebinarIdInvitesImportRoute,WebinarIdMLinkCodeRoute: WebinarIdMLinkCodeRoute,WebinarIdMarketingIdRoute: WebinarIdMarketingIdRouteWithChildren,WebinarIdMarketingImportRoute: WebinarIdMarketingImportRoute,WebinarIdOLinkCodeRoute: WebinarIdOLinkCodeRoute,WebinarIdSLinkCodeRoute: WebinarIdSLinkCodeRoute,WebinarIdWLinkCodeRoute: WebinarIdWLinkCodeRoute,WebinarIdFollowUpIndexRoute: WebinarIdFollowUpIndexRoute,WebinarIdInvitesIndexRoute: WebinarIdInvitesIndexRoute,WebinarIdMarketingIndexRoute: WebinarIdMarketingIndexRoute,WebinarIdPollsIndexRoute: WebinarIdPollsIndexRoute,WebinarIdFollowUpFollowUpIdProcessedRoute: WebinarIdFollowUpFollowUpIdProcessedRoute,WebinarIdPollsPollIdWeightingRoute: WebinarIdPollsPollIdWeightingRoute,WebinarIdFollowUpFollowUpIdIndexRoute: WebinarIdFollowUpFollowUpIdIndexRoute
}

const WebinarIdRouteWithChildren = WebinarIdRoute._addFileChildren(WebinarIdRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,WebinarIdRoute: WebinarIdRouteWithChildren,AccessDeniedRoute: AccessDeniedRoute,CreateRoute: CreateRoute,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,NotFoundRoute: NotFoundRoute,OnDemandRoute: OnDemandRoute,RegisterRoute: RegisterRoute,SwitchAccountRoute: SwitchAccountRoute,TestSuiteRoute: TestSuiteRoute,UpcomingRoute: UpcomingRoute,AccountManagerInviteInviteCodeRoute: AccountManagerInviteInviteCodeRoute,AccountTabRoute: AccountTabRoute,ManageBlacklistRoute: ManageBlacklistRoute,ManageChatLinkDomainsRoute: ManageChatLinkDomainsRoute,ManageEmailStyleRoute: ManageEmailStyleRoute,ManageTranslationRoute: ManageTranslationRoute,ManageUsageStatisticsRoute: ManageUsageStatisticsRoute,ManageWebinarDurationRoute: ManageWebinarDurationRoute,OrganizedTabRoute: OrganizedTabRoute,RAccountInviteIdRoute: RAccountInviteIdRoute,ResetPasswordResetCodeRoute: ResetPasswordResetCodeRoute,UnsubscribeTokenRoute: UnsubscribeTokenRoute,VerifyAccountVerificationCodeRoute: VerifyAccountVerificationCodeRoute,WLinkCodeRoute: WLinkCodeRoute,ManageIndexRoute: ManageIndexRoute,OrganizedIndexRoute: OrganizedIndexRoute,ManageAccountInvitesImportRoute: ManageAccountInvitesImportRoute,ManageEmailListsIdRoute: ManageEmailListsIdRoute,ManageEmailListsImportRoute: ManageEmailListsImportRoute,ManageAccountInvitesIndexRoute: ManageAccountInvitesIndexRoute,ManageEmailListsIndexRoute: ManageEmailListsIndexRoute,ManageEmailTemplateIndexRoute: ManageEmailTemplateIndexRoute,ManageEmailTemplateTemplateTypeSubTemplateRoute: ManageEmailTemplateTemplateTypeSubTemplateRoute,ManageEmailTemplateTemplateTypeIndexRoute: ManageEmailTemplateTemplateTypeIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)